/*
 * @Description: 首页
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-10 10:04:13
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-15 21:20:17
 */
import React ,{ useEffect ,useState } from 'react';
import { ActiveTitle, OfficeNotice, CityBlock, VrBlock } from '../../component' ;
import { indexPageOptions, indexVrList ,indexCityList } from '../../util/api' ;


const IndexPage = () =>{
  const [data, setData] = useState({}) ;
  const [vrlist,setVr] = useState([]) ;
  const [citylist,setCity] = useState([]) ;
  const protocol = window.location.protocol ;

  useEffect( async() =>{
    let res1 = await indexPageOptions() ;
    let res2 = await indexVrList() ;
    let res3 = await indexCityList();
    setData(res1) ;
    setVr(res2) ;
    setCity(res3) ;
  },[]) ;
  
  useEffect(() => {
    // console.log('00000indexpage',Object.keys(data).length);
  })
  
  return(
    <div className="indexpage-block">
      <ActiveTitle/>
      {
        Object.keys(data).length > 0 
        ? <OfficeNotice data={data.notice} proto={protocol}/>
        : ""
      }
      {
        citylist.length >0 
        ? <CityBlock data={citylist}/>
        : ""
      }
      {
        vrlist.length > 0 
        ? <VrBlock data={vrlist}/>
        : ""
      }
      {/* <VrBlock/> */}
      {
        Object.keys(data).length > 0 
        ? <div className="advice-block">
            <div className="advice-button" style={{background:`url(${data.web1.logo}) no-repeat`,backgroundSize:'contain'}}>
              <a href={data.web1.url.match(/(http|https):\/\/([\w.]+\/?)\S*/) ? `${data.web1.url}` : `${protocol}//${data.web1.url}`} target="_blank"></a>
            </div>
            <div className="advice-button" style={{background:`url(${data.web2.logo}) no-repeat`,backgroundSize:'contain'}}>
              <a href={data.web2.url.match(/(http|https):\/\/([\w.]+\/?)\S*/) ? `${data.web2.url}` : `${protocol}//${data.web2.url}`} target="_blank"></a>
            </div>
          </div>
        : "" 
      }
      <div className="bottom-logo-block"></div>
    </div>
  )
  
}

export default IndexPage ;